<template>
  <BLayout :colors="$site.colors" :header-title="$t('pages.customer.login.index.title')" :header-back-route="homeRoute">
    <BContainer class="mt-12">
      <div class="max-w-sm mx-auto">
        <BErrors :errors="errors" />

        <div>
          <p class="text-secondary mb-4 text-sm">
            {{ $t('pages.customer.login.index.weveSentYouACode', { email: email }) }}
          </p>

          <div>
            <ElementsOtpInput v-model="code" @complete="codeLogin" />

            <UButton disabled="true" :loading="loggingIn" block size="lg" class="mt-6">
              {{ $t('pages.customer.login.index.login') }}
            </UButton>
          </div>
        </div>
      </div>
    </BContainer>
  </BLayout>
</template>

<script setup lang="ts">
const { $api, $auth, $site, $i18n } = useNuxtApp()
const route = useRoute()

definePageMeta({
  tabs: ['user']
});

const loggingIn = ref(false)
const redirect = ref()
const email = ref()
const customer = ref()
const token = ref()
const errors = ref()
const expired = ref(false)
const code = ref('')
const homeRoute = computed(() => {
  const locationStore = useLocationStore()

  return locationStore?.homeRoute || { path: '/' }
})

onMounted(async () => {
  // http://dave.bookapp.localhost:3000/customer/login/code?email=jarred.jenkinson@gmail.com&customer=8194043
  const query = route.query

  if (query.customer && query.email) {
    const _customer = query.customer
    const _email = query.email
    const _expired = query.expired

    const response = await $auth.requestLoginCode({ id: _customer }, _email)

    redirect.value = query.redirect || null
    customer.value = _customer
    email.value = _email
    expired.value = _expired
    token.value = response.token

    errors.value = response.errors
  }
})

const codeLogin = async (c) => {
  if ((c || '').length != 6) {
    errors.value = [$i18n.t('pages.customer.login.index.validateCode')]
    return
  }

  loggingIn.value = true

  try {
    if (email.value) {
      const response = await $auth.loginWithCode(
        { id: customer.value },
        email.value,
        token.value,
        c || code
      )
  
      if (response.token) {
        navigateTo({ path: '/customer' })
      }

      if (response.errors) {
        errors.value = response.errors
      }
    }
  } catch (error: any) {
    console.log(error)
    errors.value = error.errors
  }

  loggingIn.value = false
}

</script>

<style>
  .otp-input {
    width: 100%;
    height: 60px;
    padding: 5px;
    margin: 0 5px;
    font-size: 30px;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
